// Libs
import classNames from 'classnames/bind';
import { IconEndLine, Img, Modal, View } from '@instructure/ui';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './ModalLirn.module.scss';

type Props = {
  isModalOpen: boolean;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const ModalLirn = (props: Props) => {
  //#region Destructuring Props
  const { isModalOpen, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/home', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Modal open={isModalOpen} label='' size='medium'>
      <Modal.Header frameBorder={'none'}>
        <View className={cx('buttonClose')}>
          <View as={'div'} onClick={onClose} className={cx('iconCloseModal')}>
            <IconEndLine />
          </View>
        </View>
      </Modal.Header>
      <Modal.Body>
        <iframe src='https://proxy.lirn.net/MiamiIntlBusUniv' width='100%' height='100%' title='LIRN Website'></iframe>
      </Modal.Body>
    </Modal>
  );
};

export default ModalLirn;
